// CHECKOUT SYSTEM

function agreeTerms() {
 
  if(document.getElementById('xteticTerms').checked){
    document.getElementById('xteticTerms').disabled = true;
    document.getElementById('icon-load-2').style.display = "inline-block";
    setTimeout(function() {
      document.getElementById('icon-load-2').style.display = "none";
      document.getElementById('checkout').disabled = false;
      document.getElementById('xteticTerms').disabled = false;
          }, 3000);
  }else{
    document.getElementById('checkout').disabled = true;
  }
}

function agreeTermsDrawer() {
  if(document.getElementById('xteticTermsDrawer').checked){
    document.getElementById('xteticTermsDrawer').disabled = true;
    document.getElementById('icon-load').style.display = "inline-block";
    setTimeout(function() {
      document.getElementById('icon-load').style.display = "none";
      document.getElementById('checkoutDrawer').disabled = false;
      document.getElementById('xteticTermsDrawer').disabled = false;
          }, 3000);
  }else{
    document.getElementById('checkoutDrawer').disabled = true;
  }
}



function resetCheckoutButton() {
  document.getElementById('checkout').disabled = true;
  document.getElementById('checkoutDrawer').disabled = true;
  document.getElementById('xteticTerms').checked = false;
  document.getElementById('xteticTermsDrawer').checked = false;
}

document.addEventListener('DOMContentLoaded', function() {
  // Tu código aquí se ejecutará cuando el DOM esté completamente cargado

  // Por ejemplo, puedes agregar un event listener a un elemento al cargar el DOM
  let checkoutDrawer = document.getElementById('checkoutDrawer');
  if (checkoutDrawer) {
    checkoutDrawer.addEventListener('click', function() {
      window.location.href = '/checkout';
    });
  }
});


